import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";

const WishListBtn = ({
  product,
  productId,
  wishList,
  addProductToWishList,
}) => {
  const [wished, setWished] = useState(false);
  const isProductWished = () => {
    return (
      wishList &&
      wishList.list?.some((product) => product._id === productId)
    );
  };

  const handleAddToWishList = () => {
    addProductToWishList(product);
    setWished(true);
  };

  return (
    <div className="w-full md:w-1/3 px-2">
      <Tooltip
        title={
          isProductWished() || wished
            ? `${product.name} is in your list.`
            : null
        }
      >
        <span>
          <button
            disabled={isProductWished() || wished ? true : false}
            className="flex flex-wrap w-half ml-0 py-4 px-2 items-center justify-center leading-8 font-heading font-medium tracking-tighter text-xl text-center bg-white focus:ring-2 focus:ring-gray-200 focus:ring-opacity-50 hover:bg-opacity-60 rounded-xl"
            onClick={() => handleAddToWishList(product)}
          >
            <span className="mr-2">Wishlist</span>
            <svg
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill={isProductWished() || wished ? "red" : "white"}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.3235 20.1324L2.52488 10.8515C1.75232 10.0706 1.24237 9.06367 1.06728 7.97339C0.8922 6.88311 1.06086 5.76477 1.54936 4.7768V4.7768C1.91837 4.03089 2.45739 3.3843 3.12201 2.89033C3.78663 2.39635 4.55781 2.06911 5.37203 1.93558C6.18626 1.80205 7.0202 1.86605 7.80517 2.1223C8.59013 2.37855 9.30364 2.81972 9.88691 3.40946L11.3235 4.86204L12.7601 3.40946C13.3434 2.81972 14.0569 2.37855 14.8419 2.1223C15.6269 1.86605 16.4608 1.80205 17.275 1.93558C18.0892 2.06911 18.8604 2.39635 19.525 2.89033C20.1897 3.3843 20.7287 4.03089 21.0977 4.7768V4.7768C21.5862 5.76477 21.7549 6.88311 21.5798 7.97339C21.4047 9.06367 20.8947 10.0706 20.1222 10.8515L11.3235 20.1324Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </span>
      </Tooltip>
    </div>
  );
};

export default WishListBtn;
